import { css } from 'styled-components';

export const CssA11y = css`
  [data-focus-visible] {
    outline: 3px solid var(--color-neutral-800);
    outline-offset: 0;
  }

  [aria-disabled=true] {
    pointer-events: none;
    opacity: 0.5;
  }

  .--reduced-motion,
  .--force-reduced-motion {
    * {
      animation: none!important;
      transition: none!important;
    }
  }
`;
